<template>
  <div>
    <template v-if="isImage(item)">
      <img
        :src="computedFileUrl"
        :alt="item.name"
        class="max-w-xs max-h-60 rounded-lg cursor-pointer mb-2"
        @click="handleClick"
      />
    </template>
    <template v-else>
      <div
        class="flex flex-row h-8 items-center px-3 bg-black rounded-3xl border border-black"
        @click="handleClick"
      >
        <img class="w-5 h-5 m-2" :src="getIcon(item)" />
        <span>{{ item.name }}</span>
        <template v-if="visibleClose">
          <i class="el-icon-close ml-4" @click.stop="handleClose" />
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import ImageFile from "@/assets/image-file.png";
import ImageXls from "@/assets/image-xls.png";
import ImageDoc from "@/assets/image-doc.png";
import ImagePpt from "@/assets/image-ppt.png";
import ImagePng from "@/assets/image-png.png";
import ImageJpg from "@/assets/image-jpg.png";
import ImageGif from "@/assets/image-gif.png";

export default {
  name: "ItemFile",
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    visibleClose: {
      type: Boolean,
      default: false,
    },
  },
  computed:{
    computedFileUrl(){
      console.log("item.content:", this.item.content);
      return this.item.content || this.item.url;
    }
  },
  methods: {
    getIcon(item) {
      switch (item.type) {
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        case "application/vnd.ms-excel":
        case "text/csv":
          return ImageXls;
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        case "text/plain":
          return ImageDoc;
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
          return ImagePpt;
        case "image/png":
          return ImagePng;
        case "image/jpeg":
          return ImageJpg;
        case "image/gif":
          return ImageGif;
        default:
          return ImageFile;
      }
    },
    isImage(item) {
      console.log("item.type:", item.type);
      return [
        "image/png",
        "image/jpeg",
        "image/gif",
        "image/jpg",
        "image/webp",
        "image/tiff"
      ].includes(item.type);
    },
    handleClick() {
      this.$emit("click", this.item);
    },
    handleClose() {
      this.$emit("close", this.item);
    },
  },
};
</script>